// PURPOSE: Displays executions table
// EXTRACTED FROM: Current index.js Executions Table

import React from 'react';
import { Table, Tag } from 'antd';
import PropTypes from 'prop-types';

import { FORMAT } from '../../../../../utilities/functions';

import './styles.scss';

const columns = [
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        ellipsis: true
    },
    {
        title: 'Symbol',
        dataIndex: 'symbol',
        key: 'symbol'
    },
    {
        title: 'Side',
        dataIndex: 'side',
        key: 'side'
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price'
    },
    {
        title: 'Qty',
        dataIndex: 'quantity',
        key: 'quantity'
    },
    {
        title: 'P&L',
        dataIndex: 'realizedGain',
        key: 'realizedGain',
        render: (netPnL) => {
            let color;
            const value = FORMAT.CURRENCY_TO_NUMBER(netPnL);
            if (value > 0) {
                color = '#29a373';
            } else if (value < 0) {
                color = '#E57373';
            } else {
                color = 'grey';
            }
            return (
                <Tag color={color} key={netPnL}>
                    {netPnL}
                </Tag>
            );
        }
    }
];

export default function ExecutionsTab({ executions }) {
    return (
        <div className="executions-tab">
            <Table
                rowKey={(record) => record.date + record.quantity}
                columns={columns}
                dataSource={executions}
                pagination={false}
                size="small"
                scroll={{ y: 'calc(100vh - 280px)' }}
            />
        </div>
    );
}

ExecutionsTab.propTypes = {
    executions: PropTypes.array
};

ExecutionsTab.defaultProps = {
    executions: []
};
